import { Link } from "gatsby";
import { css, styled } from "styled-components";

import { LG_WIDTH } from "styles/theme/layout";

export const PersonDetails = styled.div`
  background: rgba(27, 33, 54, 0.6);
  backdrop-filter: blur(10px);
  color: ${({ theme }) => theme.colors.white};
  border-radius: 0 0 8px 8px;
  transform: translate3d(0, 0, 0);
`;

export const PersonImage = styled.div<{
  $image: string;
  $isRelative?: boolean;
}>`
  background-image: url(${({ $image }) => $image});
  position: ${({ $isRelative }) => ($isRelative ? "relative" : "absolute")};
  border-radius: 8px;
  width: 100%;
  height: 100%;
  background-size: cover;
`;

export const IconWrapper = styled.div`
  justify-content: flex-end;
  display: none;
`;

const wrapperStyles = css`
  border-radius: 8px;
  aspect-ratio: 1 / 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;

  &:hover {
    cursor: pointer;
    justify-content: stretch;

    ${IconWrapper} {
      display: flex;
    }

    ${PersonDetails} {
      flex: 1;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
`;

export const BoardPersonWrapper = styled.div`
  ${wrapperStyles}
`;

export const PersonWrapper = styled(Link)`
  ${wrapperStyles}
`;

export const PersonTitle = styled.div`
  ${({ theme }) => theme.typography.bodyText["b6bold"]};
  @media (min-width: ${LG_WIDTH}px) {
    ${({ theme }) => theme.typography.bodyText["b3bold"]};
  }
`;
export const PersonRole = styled.div`
  ${({ theme }) => theme.typography.bodyText["b7reg"]};
  @media (min-width: ${LG_WIDTH}px) {
    ${({ theme }) => theme.typography.bodyText["b4reg"]};
  }
`;

export const PersonSocials = styled.div`
  a {
    display: inline-block;
    color: ${({ theme }) => theme.colors.vividBlue};
    border-bottom: 1px solid ${({ theme }) => theme.colors.sectionBorder};
  }

  svg {
    display: inline-block;
    margin-bottom: 1px;
    margin-left: 3px;
  }
`;

export const BoardPersonDetails = styled.div``;
